<template>
    <div>
        <ValidationObserver ref="form">
            <b-row>
                <b-col cols="12" md="12">
                    <ValidationProvider name="question" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('question')">
                            <b-form-input type="text"
                                          v-model="formData.question"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="point" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('score')">
                            <b-form-input type="number"
                                          v-model="formData.point"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="8">
                    <ValidationProvider name="course_outcome_ids" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('course_outcomes')">
                            <multi-selectbox v-model="formData.course_outcome_ids"
                                             :options="outcomeOptions"
                                             :multiple="true"
                                             :validateError="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col class="mt-3 d-flex">
                    <b-button @click="createForm" variant="primary" class="btn-lg mr-2">{{ $t("save") }}</b-button>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
import CourseOutcome from "@/services/CourseOutcome"
import ExamQuestionsService from "@/services/ExamQuestionsService"
//Components
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import qs from "qs";

export  default {
    components: {
        MultiSelectbox
    },

    props:{
        examExamId:{
            type:Number
        },
        courseId: {
            type: Number
        },
        updateData: {
            type: Object
        }
    },

    data(){
        return{
            formData:{},
            outcomeOptions: [],
            userData: null,
        }
    },
    created(){
        if(this.updateData){
            let outcomes = []
            this.updateData.course_outcomes.forEach(outcome => {
                outcomes.push(outcome.course_outcome_id)
            })
            this.formData = {
                question: this.updateData.question,
                point: this.updateData.point,
                course_outcome_ids: outcomes
            }
        }
        this.userData = this.$store.getters['auth/getUser']
        this.getOutcomes()

    },
    methods:{
        async createForm(){
            let isValid = await this.$refs.form.validate()
            if(isValid){
                if(this.updateData){
                    ExamQuestionsService.put(this.formData, this.updateData.id).then(response=>{
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.$emit('successForm',true)
                    }).catch(err=>{
                        this.showErrors(err)
                    })
                } else {
                    ExamQuestionsService.store(this.formData, this.examExamId).then(response=>{
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.$emit('successForm',true)
                    }).catch(err=>{
                        this.showErrors(err)
                    })
                }

            }
        },

        getOutcomes(){
            const config = {
                params: {
                    filter: {
                        course_id: this.courseId,
                        semester_id: this.userData.active_semester.id
                    },
                    limit: -1
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            CourseOutcome.getAll(config).then(response=>{
                response.data.data.forEach(outcome =>{
                    this.outcomeOptions.push({
                        value: outcome.id,
                        text: this.getLocaleText(outcome,'name')
                    })
                })
            }).catch(e=>{
                this.showErrors(e, null)
            })
        }

    }
}
</script>
